import React from "react";
import DashColorCards from "./DashColorCards";
import MonthReport from "./MonthReport";
import EmployeeList from "./EmployeeList";
import EmployeeReport from "./EmployeeReport";
import LockedList from "./LockedList";
import style from "../../Styles/Dasbboard.module.css";

const Dashboard = ({ dashData, filterArr }) => {
  return (
    <div>
      <div className="row m-0 p-0 mt-1 mt-lg-0">

        <div className={`col-lg-8 px-0 ${style.firstdiv}`}>

          <div className="row m-0 p-0 h-100">

            <div className={`col-lg-4 px-0 pe-lg-1 ${style.DashColorCardshi}`}>
              <div className={`row m-0 p-0 h-100 d-flex ${style.dashCardCol}`}>
                <DashColorCards projectReport={dashData.projectReport[0]} />
              </div>
            </div>

            <div className={`col-lg-8 px-0 pb-2 ${style.DashColorCardshi}`}>
              <MonthReport overallStatus={dashData.overallStatus[0]} />
            </div>

            <div className={`col-12 px-0 d-flex ${style.EmployeeReportshi}`}>
              <div className="col-12 pt-1">
                <EmployeeReport
                  filterArr={{ ...filterArr }}
                  permissionTaken={dashData.permissionTaken}
                  leaveTaken={dashData.leaveTaken}
                  lockedCount={dashData.lockedCount}
                />
              </div>
            </div>

          </div>
        </div>

        <div className={`col-lg-4 px-0 pt-1 ps-1 ${style.EmployeeListshi}`}>
          <EmployeeList filterArr={{ ...filterArr }} />
        </div>

        <div className="col-lg-12 mt-lg-0 mt-2 px-0">
          <LockedList lockedCount={dashData.lockedCount} />
        </div>

      </div>
    </div>
  );
};

export default Dashboard;